import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdLogout, MdPerson } from 'react-icons/md';

function Header() {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [userName, setUserName] = useState('User');
  const [isConferenceRoomUser, setIsConferenceRoomUser] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Get user name from token or localStorage
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const firstName = payload.firstName || '';
        const secondName = payload.secondName || '';
        const fullName = `${firstName} ${secondName}`.trim() || payload.sub || 'User';
        setUserName(fullName);

        // Check if user is conference room user
        // Conference room users: email ends with @corrohealth.com BUT no firstName/secondName (no profile)
        // Admin/SuperAdmin users: also have @corrohealth.com but HAVE firstName/secondName
        const email = payload.email || payload.sub || '';
        const hasProfile = firstName || secondName;

        if (email.endsWith('@corrohealth.com') && !hasProfile) {
          setIsConferenceRoomUser(true);
        }
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    navigate('/signin');
  };

  const handleMyProfile = () => {
    setShowDropdown(false);
    navigate('/admin/my-profile');
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const getInitials = (name) => {
    return name.charAt(0).toUpperCase();
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="header-left">
          {/* Can add breadcrumbs or page title here later */}
        </div>
        <div className="header-right">
          <div className="user-profile-dropdown" ref={dropdownRef}>
            <button
              type="button"
              className="user-avatar-btn"
              onClick={toggleDropdown}
              title={userName}
            >
              <div className="user-avatar">
                {getInitials(userName)}
              </div>
              <span className="user-name">{userName}</span>
            </button>

            {showDropdown && (
              <div className="profile-dropdown-menu">
                {!isConferenceRoomUser && (
                  <>
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={handleMyProfile}
                    >
                      <MdPerson className="dropdown-icon" />
                      <span>My Profile</span>
                    </button>
                    <div className="dropdown-divider"></div>
                  </>
                )}
                <button
                  type="button"
                  className="dropdown-item logout"
                  onClick={handleLogout}
                >
                  <MdLogout className="dropdown-icon" />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
